import { createRouter, createWebHistory } from "vue-router";

const routes = [
	{ path: "/enquire", name: "enquire", component: () => import("./pages/PublicEnquiry.vue"), meta: { title: "Send an enquiry", public: true } },
	{ path: "/login", name: "login", component: () => import("./pages/Login.vue"), meta: { title: "Sign In", public: true } },
	{ path: "/register", name: "register", component: () => import("./pages/Register.vue"), meta: { title: "Register", public: true } },

	{ path: "/", name: "dashboard", component: () => import("./pages/Dashboard.vue"), meta: { title: "Dashboard" } },

	{ path: "/tours", name: "tours", component: () => import("./pages/Packages.vue"), meta: { title: "Tour Packages" } },
	{ path: "/tours/new", name: "tour-new", component: () => import("./pages/PackageForm.vue"), meta: { title: "Add Tour" } },
	{ path: "/tours/:name/edit", name: "tour-edit", component: () => import("./pages/PackageForm.vue"), meta: { title: "Edit Tour" } },
	{ path: "/tours/:name", name: "tour-detail", component: () => import("./pages/PackageDetail.vue"), meta: { title: "Tour Package" } },
	{ path: "/tour-categories", name: "tour-categories", component: () => import("./pages/TourCategories.vue"), meta: { title: "Tour Categories" } },
	{ path: "/tour-enquiry", name: "tour-enquiry", component: () => import("./pages/TourEnquiry.vue"), meta: { title: "Tour Enquiry" } },

	{ path: "/itinerary", name: "itinerary", component: () => import("./pages/Itinerary.vue"), meta: { title: "Itinerary" } },
	{ path: "/customers", name: "customers", component: () => import("./pages/Customers.vue"), meta: { title: "Customers" } },
	{ path: "/suppliers", name: "suppliers", component: () => import("./pages/Suppliers.vue"), meta: { title: "Suppliers" } },

	{ path: "/services", name: "services", component: () => import("./pages/Services.vue"), meta: { title: "Activities" } },
	{ path: "/services/rates", name: "rates", component: () => import("./pages/Rates.vue"), meta: { title: "Rates" } },

	{ path: "/quotations/new", name: "quotation-new", component: () => import("./pages/QuoteForm.vue"), meta: { title: "Create Quotation" } },
	{ path: "/quotations", name: "quotations", component: () => import("./pages/Quotations.vue"), meta: { title: "Quotations" } },
	{ path: "/bookings", name: "bookings", component: () => import("./pages/Bookings.vue"), meta: { title: "Bookings" } },
	{ path: "/bookings/:name/itinerary", name: "booking-itinerary", component: () => import("./pages/BookingDocument.vue"), meta: { title: "Itinerary" } },
	{ path: "/bookings/:name/voucher/:service", name: "booking-voucher", component: () => import("./pages/BookingDocument.vue"), meta: { title: "Voucher" } },
	{ path: "/bookings/:name", name: "booking-detail", component: () => import("./pages/BookingDetail.vue"), meta: { title: "Booking" } },
	{ path: "/operations", name: "operations", component: () => import("./pages/SupplierRequests.vue"), meta: { title: "Supplier Requests" } },

	{ path: "/payments", name: "payments", component: () => import("./pages/Payments.vue"), meta: { title: "Payments" } },
	{ path: "/invoices", name: "invoices", component: () => import("./pages/Invoices.vue"), meta: { title: "Invoices" } },

	{ path: "/reports", name: "reports", component: () => import("./pages/Reports.vue"), meta: { title: "Reports" } },
	{ path: "/settings", name: "settings", component: () => import("./pages/Settings.vue"), meta: { title: "Settings" } },
	{ path: "/desk/:doctype", name: "desk", component: () => import("./pages/DoctypeDesk.vue"), meta: { title: "Records" } },

	{ path: "/:pathMatch(.*)*", name: "not-found", component: () => import("./pages/NotFound.vue") },
];

// The Vue desk runs on its own host. ERPNext is reached through /api.
const router = createRouter({
	history: createWebHistory("/"),
	routes,
	scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach(async (to) => {
	const { loadSession, session } = await import("./api/session");
	if (!session.loaded) await loadSession();

	const signedIn = session.user && session.user !== "Guest";
	if (to.meta.public) {
		if (signedIn && (to.name === "login" || to.name === "register")) return { path: "/" };
		return true;
	}
	if (!signedIn) {
		return { name: "login", query: { redirect: to.fullPath } };
	}
	return true;
});

router.afterEach((to) => {
	document.title = to.meta.title ? `${to.meta.title} | Trip Planner` : "Trip Planner";
});

export default router;
